module.exports = __webpack_public_path__ + "a49cacf58bd62bdf1405b1ff0709abb6.svg";